import { createApiPdfV2, createApiV2 } from "./common";

export const postGeneratePdf = (payload) => (token) =>
  createApiPdfV2("POST", "generate_pdf/", { responseType: "json" })(token, payload);

export const getCompanyTemplates = () => (token) =>
  createApiV2("GET", "pdf/company_templates/")(token);

export const getGlobalTemplates = () => (token) =>
  createApiV2("GET", "pdf/global_templates/")(token);

export const getDefaultTemplateByType = (type) => (token) =>
  createApiV2("GET", `pdf/default_template/?template_key=${type}`)(token);

export const postGenerateInvoice = (data) => (token) =>
  createApiV2("POST", "pdf/generate_invoice/")(token, data);

export const postGeneratePartialInvoice = (data) => (token) =>
  createApiV2("POST", "pdf/generate_partial_invoice/")(token, data);

export const postEmailPdf =
  ({ orderUid, customerUid, data }) =>
  (token) =>
    createApiV2("POST", `customers/${customerUid}/orders/${orderUid}/email/`)(token, data);

export default {};
